// extracted by mini-css-extract-plugin
export default {"top":"AutumnPaywall_top__e5L1D","topBackground":"AutumnPaywall_topBackground__7YoYn","bottom":"AutumnPaywall_bottom__f6Aq2"};